<template>
    <div class="tips">
        <div class="container section">
            <title-block headline="<b>Tips & tricks</b>" class="mb-xl" position="center">
                <p slot="text">
                    
                </p>
            </title-block>
            <div v-if="tips.length">
                <div class="tip__group" v-for="tipGroup in tips.filter(x => x.tips.length)" :key="tipGroup.group">
                    <div class="tip__group__headline">
                        <i class="fas fa-th-large fa-fw" v-if="tipGroup.group === 'Overblik'"></i>
                        <i class="fas fa-clock fa-fw" v-if="tipGroup.group === 'Mulige indsatser'"></i>
                        <i class="fas fa-wallet fa-fw" v-if="tipGroup.group === 'Økonomi'"></i>
                        <i class="fas fa-briefcase fa-fw" v-if="tipGroup.group === 'Kunder'"></i>
                        <i class="fas fa-clipboard-list-check fa-fw" v-if="tipGroup.group === 'Opgaver'"></i>
                        <i class="fas fa-users fa-fw" v-if="tipGroup.group === 'Medarbejdere'"></i>
                        <i class="fas fa-user-hard-hat fa-fw" v-if="tipGroup.group === 'Ansvarlige'"></i>
                        <i class="fas fa-star fa-fw" v-if="tipGroup.group === 'Potentiale'"></i>
                        <i class="fas fa-cog fa-fw" v-if="tipGroup.group === 'Indstillinger'"></i>
                        <i class="fas fa-tools fa-fw" v-if="tipGroup.group === 'Entreprise'"></i>
                        <i class="fas fa-money-check-edit-alt fa-fw" v-if="tipGroup.group === 'Læg budget'"></i>
                        &nbsp;
                        {{ tipGroup.group }}
                    </div>
                    <div class="tip__wrapper">
                        <div class="tip__single" v-for="(tip, index) in tipGroup.tips" :key="`${tipGroup.group}_${index}`">
                            <div class="inner" :class="{'show': show === tip.id}">
                                <div class="headline" @click="show === tip.id ? show = null : show = tip.id">
                                    <div class="left">
                                        {{ tip.headline }}
                                    </div>
                                    <div class="right">
                                        <i class="fas fa-plus fa-fw" v-if="show !== tip.id"></i>
                                        <i class="fas fa-minus fa-fw" v-if="show === tip.id"></i>
                                    </div>
                                </div>
                                <div class="content" v-show="show === tip.id" v-html="tip.content"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.tip__single a {
    color: #03a9f4;
    font-weight: 700;
    text-decoration: underline;
}
</style>

<style lang="scss" scoped>
@import "../../styles/vars.scss";

    .tip {
        color: #172b43;
        
        &__group {
            margin-top: 50px;

            &__headline {
                font-weight: 700;
                font-size: 20px;
                margin-bottom: 10px;
            }
        }

        &__wrapper {
            display: flex;
            flex-wrap: wrap;
            margin-left: -15px;
            margin-right: -15px;
            margin-top: -15px;
        }

        &__single {
            margin-top: 30px;
            flex: 0 0 50%;
            padding: 0 15px;

            .inner {
                background: #fff;
                // padding: 15px;
                border-radius: $borderradius--large;
                box-shadow: $boxshadow--main;
                overflow: hidden;

                .headline {
                    user-select: none;
                    cursor: pointer;
                    padding: 15px;
                    font-size: 14px;
                    display: flex;
                    justify-content: space-between;

                    .left {
                        flex-shrink: 0;
                        flex-grow: 1;
                    }
                }

                .content {
                    font-size: 14px;
                    padding: 15px;

                     a {
                        color: #03a9f4;
                        font-weight: 700;
                        text-decoration: underline;
                    }
                }

                &.show {
                    
                    .headline {
                        background: #172b43;
                        color: #fff;
                    }
                }
            }
        }
    }
</style>

<script>
import * as tipService from '@/services/tipService'

export default {
    data () {
        return {
            tips: [],
            show: null
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        getData () {
            tipService.list({}, response => {
                this.tips = response.data
            }, (err) => {
                alert('Der skete en fejl...')
                console.log(err)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// tips.vue?3d44690b